module.exports = __webpack_public_path__ + "img/about.91e2dfce.jpg";